import Vue from "vue";
import App from "./App.vue";
import Bookables from "./Bookables.vue";
import store from "./store/index";

import "./plugins/vcalendar";
import "v-calendar/lib/v-calendar.min.css";
import "./assets/styles/main.scss";

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#js-availability");

new Vue({
  store,
  render: h => h(Bookables)
}).$mount("#js-bookables");
